import Aos from "aos";
import 'slick-carousel';

jQuery( document ).ready(function($) {
    console.log('test')
    $('#map .item').on('mouseenter', function(e){
        let target = $(this).attr('data-select');
        let newImg = '#map .photo img:nth-child(' + target + ')';
        console.log(target);
        $('#map .photo img').removeClass('selected'); 
        $(newImg).addClass('selected');
    })
 
    $('.menu-toggle').on('click', function(e){
        e.preventDefault();
        $('.menu-toggle').toggleClass('open');
        $('#header .menu').toggleClass('open');
    })

    $('.search-toggle').on('click', function(e){
        e.preventDefault();
        $('.search-wrapper').toggleClass('active');
    })


    $('.photos-carousel').slick({
        infinite: true,
        slidesToShow: 5,
        swipeToSlide: true,
        centerMode: true,
        prevArrow: '<button type="button" class="slick-prev"><svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="54.844" height="31.688" viewBox="0 0 54.844 31.688"><g data-name="Group 99" transform="translate(-1053.5 -1826)"><line data-name="Line 5" x2="46.313" transform="translate(1053.5 1841.844)" fill="none" stroke="#cf954c" stroke-width="3"/><path data-name="Polygon 1" d="M15.844,0,31.688,14.625H0Z" transform="translate(1108.344 1826) rotate(90)" fill="#cf954c"/></g></svg></button>',
        nextArrow: '<button type="button" class="slick-next"><svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="54.844" height="31.688" viewBox="0 0 54.844 31.688"><g data-name="Group 99" transform="translate(-1053.5 -1826)"><line data-name="Line 5" x2="46.313" transform="translate(1053.5 1841.844)" fill="none" stroke="#cf954c" stroke-width="3"/><path data-name="Polygon 1" d="M15.844,0,31.688,14.625H0Z" transform="translate(1108.344 1826) rotate(90)" fill="#cf954c"/></g></svg></button>',
        responsive: [
        {
        breakpoint: 900,
        settings: {
            slidesToShow: 2,
        }
        }
        ]
    });  

    $('.office-carousel').slick({
        infinite: true,
        slidesToShow: 1,
        swipeToSlide: true,
        prevArrow: '<button type="button" class="slick-prev"><svg aria-hidden="true" class="arrow" xmlns="http://www.w3.org/2000/svg" width="22.5" height="13" viewBox="0 0 22.5 13"><g data-name="Group 5" transform="translate(-1053.5 -1826)"><line data-name="Line 5" x2="19" transform="translate(1053.5 1832.5)" fill="none" stroke-width="3"/><path data-name="Polygon 1" d="M6.5,0,13,6H0Z" transform="translate(1076 1826) rotate(90)" /></g></svg></button>',
        nextArrow: '<button type="button" class="slick-next"><svg aria-hidden="true" class="arrow" xmlns="http://www.w3.org/2000/svg" width="22.5" height="13" viewBox="0 0 22.5 13"><g data-name="Group 5" transform="translate(-1053.5 -1826)"><line data-name="Line 5" x2="19" transform="translate(1053.5 1832.5)" fill="none" stroke-width="3"/><path data-name="Polygon 1" d="M6.5,0,13,6H0Z" transform="translate(1076 1826) rotate(90)" /></g></svg></button>',
    });  
    
    $('.photos-carousel-scroll').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        swipeToSlide: true,
        centerMode: true,
        adaptiveWidth: true,
        prevArrow: '<button type="button" class="slick-prev"><svg aria-hidden="true" class="arrow" xmlns="http://www.w3.org/2000/svg" width="22.5" height="13" viewBox="0 0 22.5 13"><g data-name="Group 5" transform="translate(-1053.5 -1826)"><line data-name="Line 5" x2="19" transform="translate(1053.5 1832.5)" fill="none" stroke-width="3"/><path data-name="Polygon 1" d="M6.5,0,13,6H0Z" transform="translate(1076 1826) rotate(90)" /></g></svg></button>',
        nextArrow: '<button type="button" class="slick-next"><svg aria-hidden="true" class="arrow" xmlns="http://www.w3.org/2000/svg" width="22.5" height="13" viewBox="0 0 22.5 13"><g data-name="Group 5" transform="translate(-1053.5 -1826)"><line data-name="Line 5" x2="19" transform="translate(1053.5 1832.5)" fill="none" stroke-width="3"/><path data-name="Polygon 1" d="M6.5,0,13,6H0Z" transform="translate(1076 1826) rotate(90)" /></g></svg></button>',
        responsive: [
        {
        breakpoint: 900,
        settings: {
            slidesToShow: 2,
        }
        }
        ]
    }); 


    Aos.init({
    disable: function() {
        return window.innerWidth < 500;
    }
});

});